import queryString from 'query-string'
import { matchPath, PathPattern } from 'react-router'

/**
 * Use the matchesPath helper instead to match against path patterns instead.
 *
 * @deprecated
 */
export function isRoute(route: string) {
  return window.location.pathname === route
}

// Wrapper around react-router's matchPath function (https://reactrouter.com/en/main/utils/match-path)
// but which allows matching against multiple path patterns.
export function matchesPaths(
  path: string,
  pathPatterns: Array<string | PathPattern>,
) {
  return pathPatterns.some((pattern) => matchPath(pattern, path))
}

export function matchesPath(path: string, pathPattern: string | PathPattern) {
  return !!matchPath(pathPattern, path)
}

interface GetQueryParamOptions<T> {
  name: string
  transform?: (value: unknown) => T
  defaultValue?: T | null
}

export function getQueryParam<T>(options: GetQueryParamOptions<T>) {
  const { name, transform, defaultValue } = options
  const value = queryString.parse(window.location.search)[name]

  if (typeof transform === 'function') {
    return transform(value) as T
  }

  return (value || defaultValue) as T
}

export function currentUrl() {
  return window.location.pathname + window.location.search
}

export function absoluteUrl(path: string): string {
  return `${window.location.origin}${path}`
}
